import { render, staticRenderFns } from "./_WorldSubEnded.vue?vue&type=template&id=e3d154d8&scoped=true&"
import script from "./_WorldSubEnded.vue?vue&type=script&lang=js&"
export * from "./_WorldSubEnded.vue?vue&type=script&lang=js&"
import style0 from "./_WorldSubEnded.vue?vue&type=style&index=0&id=e3d154d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d154d8",
  null
  
)

export default component.exports